<template>
  <div>
    <!-- <div v-if="first" class="mb-5 flex items-center">
      <el-image class="w-5" fit="cover"  src="~assets/img/company/headline-title.png" />
      <span class="ml-1 text-dark font-semibold text-2xl">邮轮头条</span>
    </div> -->
    <div class="flex">
      <nuxt-link v-if="first" class="block relative flex-1 headline-item" :class="$style.headlineItem"
        :to="`/company/article/${first.no}`" :title="first.title" target="_blank">
        <!-- <v-responsive :aspect-ratio="814 / 348"> -->
        <v-responsive :aspect-ratio="854 / 384">
          <el-image :class="$style.headlineItem__img" fit="cover" :src="first.cover" />
          <div :class="$style.headlineItem__mask">
            <h3 class="font-medium text-3xl">{{ first.title }}</h3>
            <!-- <h3 class="text-2xl">邮轮旅行攻略合集！</h3> -->
          </div>
        </v-responsive>
      </nuxt-link>
      <aside class="ml-3 w-[310px] flex flex-col justify-between">
        <nuxt-link v-for="(item, index) in others" :key="index" :class="$style.headlineItem"
          :to="`/company/article/${item.no}`" :title="item.title" target="_blank">
          <!-- <v-responsive :aspectRatio="264 / 110"> -->
          <v-responsive :aspectRatio="310 / 118">
            <el-image :class="$style.headlineItem__img" fit="cover" :src="item.cover" />
            <div :class="$style.headlineItem__mask" class="!p-3">
              <h4 class="line-clamp-1">{{ item.title }}</h4>
            </div>
          </v-responsive>
        </nuxt-link>
      </aside>
    </div>
  </div>
</template>
<script>
import { computed, toRefs } from "@nuxtjs/composition-api";
import { head } from "~/utils/helpers";
import VResponsive from "@/components/VResponsive/VResponsive.vue";
export default {
  name: "IndexHeadline",
  components: { VResponsive },
  props: {
    headlineData: {
      type: Object,
      default: () => ({ data: [] }),
    },
  },
  setup(props) {
    const { headlineData } = toRefs(props);
    const first = computed(() => {
      return head(headlineData.value.data);
    });
    const others = computed(() => {
      return headlineData.value.data.slice(1);
    });
    return {
      first,
      others,
    };
  },
};
</script>
<style lang="scss" module>
.headlineItem:hover .headlineItem__img {
  border-radius: 0.25rem;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-translate-z: 0;
  --tw-rotate: 0;
  --tw-rotate-x: 0;
  --tw-rotate-y: 0;
  --tw-rotate-z: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-scale-z: 1;
  -webkit-transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  -ms-transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), var(--tw-translate-z)) rotate(var(--tw-rotate)) rotateX(var(--tw-rotate-x)) rotateY(var(--tw-rotate-y)) rotateZ(var(--tw-rotate-z)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) scaleZ(var(--tw-scale-z));
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  --tw-scale-z: 1.05;
  -webkit-transition-duration: 1000ms;
  -o-transition-duration: 1000ms;
  transition-duration: 1000ms;
}
.headlineItem__img {
  border-radius: 0.25rem;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  -webkit-transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.headlineItem__mask {
  border-radius: 0.25rem;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 86px;
  padding-bottom: 20px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5282) 100%);
}
</style>